import React from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { cancelMessageEditable, alertError } from "actions/ui";
import { sendUserCommand, clearUserCommand } from "actions/commands";
import { replaceMessage } from "actions/messages";
import $ from "jquery";

class Edit extends React.Component {

	constructor(props) {
		super(props);

		this.handleCancelEdit = this.handleCancelEdit.bind(this);
		this.handleSaveEdit = this.handleSaveEdit.bind(this);
		this.handlePaste = this.handlePaste.bind(this);
		this.editableRef = React.createRef();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		const editStarted = prevProps.edit !== this.props.edit && this.props.edit === true;
		const editFailure = this.props.command !== prevProps.command && this.props.command && this.props.command.success === false;
		const editSuccess = this.props.command !== prevProps.command && this.props.command && this.props.command.success === true;

		if (editStarted) {
			$(this.editableRef.current).html($(this.props.contentRef.current).html()).focus();

			// disable images resizing in Mozilla:
			if (document.execCommand) {
				document.execCommand("enableObjectResizing", null, false);
			}
		}

		if (editFailure) {
			this.props.alertError(this.props.command.error);
			this.props.clearUserCommand(this.props.message.id);
		}

		if (editSuccess) {
			const editResult = this.props.command.result;
			this.props.clearUserCommand(this.props.message.id);

			if (editResult.command === 'saveMessage') {
				this.props.replaceMessage(editResult.message);
				this.props.cancelMessageEditable(this.props.message.id);
			}
		}
	}

	handleCancelEdit(e) {
		e.preventDefault();

		this.props.cancelMessageEditable(this.props.message.id);
	}

	handleSaveEdit(e) {
		e.preventDefault();

		const editedMessage = $(this.editableRef.current).html();


		this.props.sendUserCommand(this.props.message.id, 'saveMessage', {
			id: this.props.message.id,
			channelId: this.props.message.channel.id,
			content: editedMessage
		});
	}

	handlePaste(e) {
		e.preventDefault();

		e = e.nativeEvent;

		let text = '';
		if (e.clipboardData || e.originalEvent.clipboardData) {
			text = (e.originalEvent || e).clipboardData.getData('text/plain');
		} else if (window.clipboardData) {
			text = window.clipboardData.getData('Text');
		}

		if (document.queryCommandSupported('insertText')) {
			// Browsers: Edge, Chrome, Firefox, Safari
			document.execCommand('insertText', false, text);
		} else {
			// Browsers: IE 11
			let selection = null;
			if (window.getSelection) {
				selection = window.getSelection();
			} else {
				if (console) {
					console.error('getSelection unsupported');
				}
				return;
			}

			const range = selection.getRangeAt(0);
			range.deleteContents();

			const textNode = document.createTextNode(text);
			range.insertNode(textNode);
			range.selectNodeContents(textNode);
			range.collapse(false);

			selection = window.getSelection();
			selection.removeAllRanges();
			selection.addRange(range);
		}
	}

	render() {
		if (!this.props.edit) {
			return null;
		}

		return(
			<React.Fragment>
				<div ref={ this.editableRef } className="wcInternalEditing" contentEditable={ this.props.edit } onPaste={ this.handlePaste } />
				{ this.props.edit &&
					<div className="wcEditTools">
						<a href="#" className="wcFunctional wcCancelButton" title="Cancel" onClick={ this.handleCancelEdit } />
						<a href="#" className="wcFunctional wcSaveButton" title="Save the message" onClick={ this.handleSaveEdit } />
					</div>
				}
			</React.Fragment>
		)
	}

}

Edit.propTypes = {
	configuration: PropTypes.object.isRequired,
	message: PropTypes.object.isRequired,
	i18n: PropTypes.object.isRequired,
	i18nBase: PropTypes.object,
	edit: PropTypes.bool,
	contentRef: PropTypes.object,
	command: PropTypes.object
};

export default connect(
	(state, ownProps) => ({
		configuration: state.configuration,
		i18n: state.application.i18n,
		i18nBase: state.configuration.i18n,
		edit: state.ui.editableMessages[ownProps.message.id],
		command: state.commands.sent[ownProps.message.id]
	}),
	{ cancelMessageEditable, sendUserCommand, clearUserCommand, alertError, replaceMessage }
)(Edit);